module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_setting-864d6b2241c479bf8ae18b9607a810cc.svg";